import { ContextApi } from 'contexts/Localization'

export const formatLasted = (lasted: number, t: ContextApi['t']) => {
  const time = {
    seconds: Math.floor((lasted % 60000) / 1000),
    minutes: Math.floor(lasted / 60000),
  }

  return time.minutes >= 1 ? t('%minutes%m%seconds%s', time) : t('%seconds%s', time)
}
